import { Link } from "react-router-dom";
import { Rise, Words } from "../components/Reveal";
import { LeadForm } from "../components/LeadForm";
import { Anteprima } from "../components/Anteprima";
import { useTexts } from "../lib/settings";
import { COPY } from "../content/copy";
import { ImageTrigger } from "../components/viewer/ImageTrigger";
import { BOTTEGA_IMAGES } from "../components/viewer/galleries";
import { FormFirstLayout } from "../components/FormFirstLayout";
import { CookieSettingsButton } from "../components/consent/ConsentProvider";

export default function Analisi() {
    const t = useTexts();
    const a = COPY.analisi;
    const b = COPY.bottega;
    return (
        <main className="analisi" data-testid="analisi-page">
            <section className="analisi-hero">
                <FormFirstLayout testId="landing-analysis-layout" intro={<>
                        <p className="caption">{a.caption}</p>
                        <h1 className="h2 analisi-title" data-testid="analisi-title">
                            <span className="lead-desktop-copy">{a.title}</span>
                            <span className="lead-mobile-copy">{a.mobileTitle}</span>
                        </h1>
                        <p className="lead section-lead lead-desktop-copy" data-testid="analisi-description">{a.sub}</p>
                        <p className="lead section-lead lead-mobile-copy" data-testid="analisi-mobile-description">{COPY.form.mobileSub}</p>
                    </>}
                    form={<LeadForm position="analisi-top" />}
                    proof={<Anteprima id="anteprima-analisi" />}
                />
            </section>

            <section className="section analisi-section">
                <div className="container">
                    <h2 className="h2 analisi-h2"><Words text={a.receiveTitle} /></h2>
                    <ol className="deliver-list analisi-list">
                        {a.receive.map((r, i) => (
                            <li key={r}><span className="deliver-num">{String(i + 1).padStart(2, "0")}</span><span>{r}</span></li>
                        ))}
                    </ol>
                    <p className="ital analisi-note">{a.receiveNote}</p>
                </div>
            </section>

            <section className="section analisi-section">
                <div className="container">
                    <Rise><h2 className="h2 analisi-h2">{a.trustTitle}</h2></Rise>
                    <Rise delay={0.05}><p className="body analisi-text">{a.trustText}</p></Rise>
                    <Rise delay={0.1}>
                        <p className="analisi-no" data-testid="analisi-no">
                            {a.trustNo.map((n) => <span key={n}>{n}</span>)}
                        </p>
                    </Rise>
                </div>
            </section>

            <section className="section analisi-section">
                <div className="container">
                    <Rise><p className="caption">{a.caseMeta}</p></Rise>
                    <Rise delay={0.05}><h2 className="caso-title analisi-caso">{a.caseTitle}</h2></Rise>
                    <Rise delay={0.1}><p className="body analisi-text">{a.caseText}</p></Rise>
                    <Rise delay={0.15}><p className="ital analisi-result">{a.caseResult}</p></Rise>
                </div>
            </section>

            <section className="section analisi-section">
                <div className="container">
                    <Rise><p className="caption">{b.caption}</p></Rise>
                    <Rise>
                        <figure className="bottega-frame analisi-bottega">
                            <ImageTrigger images={BOTTEGA_IMAGES} className="image-trigger--desktop" testId="analisi-bottega-open">
                                <img className="bottega-shot" src={b.images.desktop} alt="La home di Bottega Paesano" loading="lazy" />
                            </ImageTrigger>
                        </figure>
                    </Rise>
                    <Rise><p className="body analisi-text">{a.bottegaText}</p></Rise>
                    <Rise><a className="tlink" href={b.link.href} target="_blank" rel="noreferrer">{b.link.label}</a></Rise>
                </div>
            </section>

            <section className="section analisi-section">
                <div className="container">
                    <Rise><h2 className="h2 analisi-h2">{a.faqTitle}</h2></Rise>
                    <dl className="faq" data-testid="analisi-faq">
                        {a.faq.map((q) => (
                            <Rise key={q.q} className="faq-item">
                                <dt>{q.q}</dt>
                                <dd>{q.a}</dd>
                            </Rise>
                        ))}
                    </dl>
                </div>
            </section>

            <section className="section analisi-section">
                <div className="container lead-grid">
                    <div>
                        <h2 className="h2 analisi-h2">{t.chiusura_title}</h2>
                        <p className="lead section-lead">{t.chiusura_sub}</p>
                    </div>
                    <div className="lead-side"><LeadForm position="analisi-bottom" /></div>
                </div>
            </section>

            <footer className="footer-bar analisi-footer">
                <div className="container footer-row">
                    <span className="footer-brand">{COPY.brand}</span>
                    <span className="caption">{COPY.footer.vat}</span>
                    <nav className="footer-links" aria-label="Informative">
                        <Link className="tlink" to="/privacy" data-testid="analisi-privacy">Privacy</Link>
                        <Link className="tlink" to="/cookie" data-testid="analisi-cookie-policy">Cookie</Link>
                        <CookieSettingsButton testId="analisi-cookie-settings" />
                    </nav>
                </div>
            </footer>
        </main>
    );
}
